import { datadogLogs } from '@datadog/browser-logs';
import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useGetUserDataQuery } from './queries/user';

/** 데이터독 초기화 */
const useInitDataDog = () => {
	const { data: user_data = null } = useGetUserDataQuery();

	useEffect(() => {
		datadogRum.init({
			applicationId: `${process.env.REACT_APP_DATADOG_APP_ID}`,
			clientToken: `${process.env.REACT_APP_DATADOG_CLIENT_TOKEN}`,
			site: 'datadoghq.com',
			service: 'featuring-enterprise-imms',
			env: `enterprise`,
			version: `${'1.1.4'}`,
			sampleRate: 100,
			sessionReplaySampleRate: 0,
			trackInteractions: true,
			trackResources: true,
			trackLongTasks: true,
			defaultPrivacyLevel: 'mask-user-input',
			enableExperimentalFeatures: ['clickmap', 'feature_flags'],
		});

		datadogLogs.init({
			clientToken: `${process.env.REACT_APP_DATADOG_APP_ID}`,
			site: 'datadoghq.com',
			forwardErrorsToLogs: true,
			env: `enterprise`,
			sampleRate: 100,
		});
	}, []);

	useEffect(() => {
		datadogRum.setUser({
			id: user_data?.pk ?? '',
			name: user_data?.username ?? '',
			email: user_data?.email ?? '',
		});
	}, [user_data]);

	useEffect(() => {
		datadogRum.stopSessionReplayRecording();
	}, [user_data]);
};

export default useInitDataDog;
